<template>
  <label v-if="label" :for="forText" class="block">
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-1">
        <span :class="small ? 'text-sm' : 'text-base'">{{ label }}</span>
        <Tooltip v-if="toolTip" :content="toolTip" placement="auto">
          <IconToolTip class="size-3.5 fill-grey-900" />
        </Tooltip>
      </div>
      <p
        v-if="helperText"
        class="uppercase tracking-wider text-grey-600"
        :class="small ? 'text-xs' : 'text-sm'"
      >
        {{ helperText }}
      </p>
    </div>
    <p v-if="description" class="!mb-3 text-sm text-grey-500">
      {{ description }}
    </p>
  </label>
</template>

<script setup lang="ts">
const props = defineProps<{
  label: string;
  for?: string;
  small?: boolean;
  toolTip?: string;
  helperText?: string;
  description?: string;
}>();

const forText = computed(() => props.for || labelCleanUp(props.label) || "");
</script>
